import { Checkbox } from '@electricjs/arc';

import { FilterDropdown } from '@common';

import { DynamicFilterKey } from '@/types/storefront';
import {
  getFilterOptionDisplayName,
  getDynamicFilterDisplayName,
} from '@/components/Storefront/utils';

type DynamicFilterDropdownProps = {
  filterKey: DynamicFilterKey;
  availableOptions: string[];
  selectedOptions: string[];
  onSelect: (newSelectedOptions: string[], filterKey: DynamicFilterKey) => void;
  loading?: boolean;
};

export const DynamicFilterDropdown = ({
  filterKey,
  availableOptions,
  selectedOptions,
  onSelect,
  loading,
}: DynamicFilterDropdownProps) => {
  const someOptionIsChecked =
    selectedOptions.filter(selectedOption =>
      availableOptions.includes(selectedOption)
    ).length > 0;

  const handleOptionCheck = (
    filterKey: DynamicFilterKey,
    filterOption: string,
    checked: boolean
  ) => {
    let newSelectedOptions;

    if (checked) {
      // add the option
      newSelectedOptions = [...selectedOptions, filterOption];
    } else {
      // remove the option
      newSelectedOptions = selectedOptions.filter(
        option => option !== filterOption
      );
    }

    onSelect(newSelectedOptions, filterKey);
  };

  return (
    <FilterDropdown
      someOptionIsChecked={someOptionIsChecked}
      dropdownContentProps={{ width: 'fit-content' }}
      dropdownContent={availableOptions.map(option => {
        return (
          <Checkbox
            id={`dynamic-filter-option-${filterKey}-${option}`}
            key={option}
            checked={selectedOptions.includes(option)}
            onChange={e =>
              handleOptionCheck(filterKey, option, e.currentTarget.checked)
            }>
            {getFilterOptionDisplayName(filterKey, option)}
          </Checkbox>
        );
      })}
      filterName={getDynamicFilterDisplayName(filterKey)}
      loading={loading}
    />
  );
};
